export default __webpack_public_path__ + "static/media/tokit2.bdc59a56.png";